module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/797c3df806ec50cd823c2e44d8671144.gif";